export const version = 'berater-v1.19.0-SNAPSHOT-391b685764bceef9c2e16963dff2451c4a61257a';